<rk-input-with-suggestions
  [label]="label"
  [hintLabel]="hintLabel"
  [disabled]="disabled"
  [placeholder]="placeholder"
  [displayIfEmpty]="false"
  [isTrack]="true"
  [displayClearButton]="true"
  [inModal]="inModal"
  [addNewCaseSensitive]="false"
  [debounceTime]="300"
  [minLengthTrigger]="0"
  [isLoadingData]="isLoadingData"
  [maxInputLength]="524288"
  [dataFetched]="tracks$ | async"
  [renderInInputFn]="renderItem"
  [renderLineTemplate]="renderItemTmpl"
  (blurred)="onBlur($event)"
  [canAddNew]="false"
  (submitted)="submitted.emit($event)"
  (changed)="onChange($event)"
></rk-input-with-suggestions>

<ng-template let-track="item" #renderItemTmpl>
  <div class="container">
    <span class="title">{{ track.title }}</span>
    <span class="artist">{{ track.artist }}</span>
  </div>
</ng-template>
